import React from "react";
import download from "downloadjs";
import { PendingButton } from "components/common";
import { noop, get, includes } from "lodash";
import { compose } from "recompose";
import { withTranslation, Trans } from "react-i18next";
import {XeroClient } from "services";
import { WtspShare } from "./utils";
import print from "print-js";

import {
  UncontrolledButtonDropdown,
  DropdownMenu,
  DropdownItem,
  DropdownToggle,
} from "reactstrap";
import DocumentEmailer from "./DocumentEmailer";
import { languageNameMapping } from "constants/mappings";

function dataURLtoBlob(dataurl) {
  var arr = dataurl.split(','), mime = arr[0].match(/:(.*?);/)[1],
      bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
  while(n--){
      u8arr[n] = bstr.charCodeAt(n);
  }
  return new Blob([u8arr], {type:mime});
}

const defer = () => {
  let resolve = null;
  let reject = null;

  const promise = new Promise(function () {
    resolve = arguments[0];
    reject = arguments[1];
  });

  return {
    resolve: resolve,
    reject: reject,
    promise: promise,
  };
};

export const withDocumentRenderer = ({
  onDownload = noop,
  type,
  orientation = "Portrait",
  footer = true,
} = {}) =>
  compose(
    withTranslation(),
    (BaseComponent) =>
      class extends React.Component {
        state = {
          documentProps: null,
          documentPending: false,
          email: false,
          filename: null,
          print: false,
          language:"en",
        };
        deferred = null;
        xero = this.props.xero || XeroClient();
        selectedOrganisation = this.props.selectedOrganisation 

        handleContentChanged = (content) => {
          const {
            state: {filename, email, documentProps, to_print, wtsp, language, is_small },
            xero,
            deferred: { resolve, reject },
          } = this;
          this.setState({
            documentProps: null,
            filename: null,
            email: false,
            language: null,
            to_print: false,
            is_small: false,
            language:language,
          });
          this.deferred = null;
          if (email && filename) {
            this.setState({
              documentPending: false,
              emailContent: content,
              filename,
            });
          } else if (to_print && filename) {
            xero
            .post("all/generate_document", {
              template: content,
                filename,
                type,
                orientation,
                footer,
                language: documentProps ? documentProps.language : null,
                is_small:is_small,
                IsSimplified:documentProps.item?.IsSimplified,
                invoiceID: documentProps.item?.InvoiceID || documentProps.item?.CreditNoteID
              })
              .then((resp) => {
                let base64 = resp.data.content.replace(/\s/g, "").split(',')[1]
                print({printable: base64, type: 'pdf', base64: true})
              }, reject)
              .finally(() => this.setState({ documentPending: false }));
          } else if (wtsp && filename) {
            const item = documentProps.item
            xero
            .post("all/generate_document", {
              template: content,
                filename,
                type,
                orientation,
                footer,
                language: documentProps ? documentProps.language : null,
                wtsp:true,
                IsSimplified:documentProps.item?.IsSimplified,
                invoiceID: documentProps.item?.InvoiceID || documentProps.item?.CreditNoteID
              })
              .then((resp) => {
                let t = this.props.t
                WtspShare(resp.data, item, xero, t)
                
              }, reject)
              .finally(() => this.setState({ documentPending: false }));
          }else if (filename) {
              xero
              .post("all/generate_document", {
                template: content,
                filename,
                type,
                orientation,
                footer,
                language: documentProps ? documentProps.language : null,
                IsSimplified:documentProps.item?.IsSimplified,
                invoiceID: documentProps.item?.InvoiceID || documentProps.item?.CreditNoteID
              })
              .then((resp) => {
                
                download(
                  resp.data.content.replace(/\s/g, ""),
                  resp.data.filename
                  );
                resolve(content);
              }, reject)
              .finally(() => this.setState({ documentPending: false }));
          } else {
            this.setState({ documentPending: false });
            resolve(content);
          }
        };

        handleDocumentAction = (documentProps, filename, email = false, to_print = false, wtsp = false, is_small = false) => {
          this.setState({
            documentProps,
            documentPending: true,
            emailContent: null,
            email,
            filename,
            to_print,
            is_small,
            wtsp,
            language: documentProps.language,
          });
          this.deferred = defer();
          return this.deferred.promise;
        };
        handleGetDocument = (documentProps, filename, language) =>
          this.handleDocumentAction({ ...documentProps, language }, filename);
        
        handleSendDocument = (documentProps, filename, language) =>
          this.handleDocumentAction({ ...documentProps, language }, filename, true);
        
        handlePrintDocument = (documentProps, filename, language, is_small) =>
          this.handleDocumentAction({ ...documentProps, language }, filename, false, true, false, is_small);
          
        handleShareDocument = (documentProps, filename, language) =>
          this.handleDocumentAction({ ...documentProps, language }, filename, false, false, true);
        
        // This is the render responsible for Downloading PDF Invoice DownloadDocument:
        renderDownloadDocument = ({
          item,
          compact,
          label,
          is_small,
          emptyButton,
          validation,
          simplified,
          setDownloadHandler, 
          ...props
        }) => { 
          
          const getLanguageAndType = (language) => () => {
            if (validation && !validation()) { 
              setDownloadHandler((updated_data) => onDownload({...this.props, item:{...item, ...updated_data}})((documentProps, filename) => this.handleGetDocument(documentProps, filename, language), {...item, ...updated_data}))
              return false;
            }

            onDownload(this.props)((documentProps, filename) => this.handleGetDocument(documentProps, filename, language), item);
          };

          let availableLangs = []

          if (this.selectedOrganisation?.is_trial) {
            availableLangs = Object.keys(languageNameMapping).filter(lang => lang !== 'en');
          } else {
            availableLangs = this.selectedOrganisation?.subscribed_features?.hesaablanguage?.filter(lang => lang !== 'en');
          }

          return (
            <UncontrolledButtonDropdown {...props}>
              <PendingButton
                pending={this.state.documentPending}
                component={DropdownToggle}
                caret
                color={simplified ? "secondary" : "primary"}
                className={`btn-sm ${compact ? "py-0" : ""}`}
                disabled = {props.disabled}
              >
                <span className={`fa fa-download ${emptyButton ? "" : "mr-1"}`}/>
                {emptyButton ? "" : <>
                {!compact ? label || <Trans>Download</Trans> : ""}</>}
              </PendingButton>
              <DropdownMenu style={{maxHeight: "300px", overflow: "auto"}}>
                <DropdownItem onClick={getLanguageAndType('en')}>
                  <Trans>English</Trans>
                </DropdownItem>
                {availableLangs?.map(lang => (
                  languageNameMapping[lang] !== undefined && languageNameMapping[lang] !== "" && (
                    <DropdownItem key={lang} onClick={getLanguageAndType(lang)}>
                      <Trans>{languageNameMapping[lang]}</Trans>
                    </DropdownItem>
                  )
                ))}
              </DropdownMenu>
            </UncontrolledButtonDropdown>
          );
        };
        // This is the render responsible for Small Invoice Download PrintDocument:
        renderPrintDocument = ({
          item,
          compact,
          simplified,
          label = this.props.t("Small Invoice"),
          is_small,
          ...props
        }) => {

          const getLanguageAndType = (language) => () => {
            onDownload(this.props)((documentProps, filename) =>
              this.handlePrintDocument(documentProps, filename, language, is_small), item);
          };

          let availableLangs = []

          if (this.selectedOrganisation?.is_trial) {
            availableLangs = Object.keys(languageNameMapping).filter(lang => lang !== 'en');
          } else {
            availableLangs = this.selectedOrganisation?.subscribed_features?.hesaablanguage?.filter(lang => lang !== 'en');
          }

          return (
            <UncontrolledButtonDropdown {...props}>
              <PendingButton
                pending={this.state.documentPending}
                component={DropdownToggle}
                caret
                color={simplified ? "secondary" : "primary"}
                className={`btn-sm ${compact ? "py-0" : ""}`}
              >
                <span className="fa fa-print mr-1" />
                {!compact && label && <Trans>{label}</Trans>}
              </PendingButton>
               <DropdownMenu>
                <DropdownItem onClick={getLanguageAndType('en')}>
                  <Trans>English</Trans>
                </DropdownItem>
                {availableLangs?.map(lang => (
                 languageNameMapping[lang] !== undefined && languageNameMapping[lang] !== "" && (
                  <DropdownItem key={lang} onClick={getLanguageAndType(lang)}>
                    <Trans>{languageNameMapping[lang]}</Trans>
                  </DropdownItem>
                  )
                ))}
              </DropdownMenu>
            </UncontrolledButtonDropdown>
          );
        };

        renderWtspDocument = ({
          item,
          compact,
          label = "Whatsapp",
          simplified,
          type,
          validation,
          setDownloadHandler,
          ...props
        }) => {
          const getLanguageAndType = (language) => () => { 
            if (validation && !validation()) { 
              setDownloadHandler((updated_data) => onDownload({...this.props, item:updated_data || item})((documentProps, filename) => this.handleShareDocument(documentProps, filename, language), item, type))
              return false;
            }
            onDownload(this.props)((documentProps, filename) => this.handleShareDocument(documentProps, filename, language), item, type);
          };

          let availableLangs = []

          if (this.selectedOrganisation?.is_trial) {
            availableLangs = Object.keys(languageNameMapping).filter(lang => lang !== 'en');
          } else {
            availableLangs = this.selectedOrganisation?.subscribed_features?.hesaablanguage?.filter(lang => lang !== 'en');
          }

          return (
            <UncontrolledButtonDropdown {...props}>
              <PendingButton
                pending={this.state.documentPending}
                component={DropdownToggle}
                caret
                color={simplified ? "secondary" : "primary"}
                className={`btn-sm mx-2 ${compact ? "py-0" : ""}`}
              >
                <span className="fab fa-whatsapp mr-1" />
                {!compact ? ` ${label}` : ""}
              </PendingButton>
              <DropdownMenu>
                <DropdownItem onClick={getLanguageAndType('en')}>
                  <Trans>English</Trans>
                </DropdownItem>
                {availableLangs?.map(lang => (
                 languageNameMapping[lang] !== undefined && languageNameMapping[lang] !== "" && (
                  <DropdownItem key={lang} onClick={getLanguageAndType(lang)}>
                    <Trans>{languageNameMapping[lang]}</Trans>
                  </DropdownItem>
                  )
                ))}
              </DropdownMenu>
            </UncontrolledButtonDropdown>
          );
        };

        // This is the render responsible for Emailing PDF Invoice EmailDocument:
        renderEmailDocument = ({
          item,
          compact,
          to,
          subject,
          content,
          simplified,
          type,
          validation,
          setDownloadHandler,
          ...props
        }) => {
          const { emailContent, filename, language } = this.state;
          const { xero } = this;
          const { InvoiceID, CreditNoteID, PurchaseOrderID, Status } = item;

          const validStatus = includes(
            ["DRAFT", "SUBMITTED", "AUTHORISED", "BILLED", "PAID"],
            Status
          );

          let data = item;
          let onSentToContact = null;
          let email = to || get(item, "Contact.EmailAddress");

          if (type === "REMITTANCE" || type === "RECEIPT") {
            const Contact =
              get(item, "Invoice.Contact") || get(item, "Contact");
            const CurrencyCode =
              get(item, "Invoice.CurrencyCode") || get(item, "CurrencyCode");

            data = {
              ...item,
              Contact,
              CurrencyCode,
            };
            email = get(Contact, "EmailAddress");
          } else if (type === "SALES_INVOICE" && validStatus) {
            onSentToContact = () =>
              xero.patch(`invoices/${InvoiceID}`, {
                SentToContact: true,
                InvoiceID,
              });
          } else if (type === "CREDIT_NOTE" && validStatus) {
            onSentToContact = () =>
              xero.put(`creditnotes/${CreditNoteID}`, {
                SentToContact: true,
                CreditNoteID,
              });
          } else if (type === "PURCHASE_ORDER" && validStatus) {
            onSentToContact = () =>
              xero.put(`purchaseorders/${PurchaseOrderID}`, {
                SentToContact: true,
                PurchaseOrderID,
              });
          }

          const getLanguageAndType = (language, email = false) => () => {
            if (validation && !validation()) { 
              setDownloadHandler((updated_data) => onDownload({...this.props, item:updated_data || item})((documentProps, filename) => this.handleSendDocument(documentProps, filename, language), item, email))
              return false;
            }
            onDownload(this.props)((documentProps, filename) => this.handleSendDocument(documentProps, filename, language), item, email);           
          };

          let availableLangs = []

          if (this.selectedOrganisation?.is_trial) {
            availableLangs = Object.keys(languageNameMapping).filter(lang => lang !== 'en');
          } else {
            availableLangs = this.selectedOrganisation?.subscribed_features?.hesaablanguage?.filter(lang => lang !== 'en');
          }
          
          return (
            <React.Fragment>
              <UncontrolledButtonDropdown {...props}>
                <PendingButton
                  pending={this.state.documentPending}
                  component={DropdownToggle}
                  caret
                  color={simplified ? "secondary" : "primary"}
                  className={`btn-sm ${compact ? "py-0" : ""}`}
                  disabled={props.disabled}
                >
                  <span className="fa fa-envelope mr-1" />
                  {!compact ? " Email" : ""}
                </PendingButton>
                <DropdownMenu>
                  <DropdownItem onClick={getLanguageAndType('en')}>
                    <Trans>English</Trans>
                  </DropdownItem>
                  {availableLangs?.map(lang => (
                    languageNameMapping[lang] !== undefined && languageNameMapping[lang] !== "" && (
                    <DropdownItem key={lang} onClick={getLanguageAndType(lang)}>
                      <Trans>{languageNameMapping[lang]}</Trans>
                    </DropdownItem>
                    )
                  ))}
              </DropdownMenu>
              </UncontrolledButtonDropdown>
              {!!emailContent && (
                <DocumentEmailer
                  isModalOpen={true}
                  initialState={{
                    email,
                  }}
                  type={type}
                  data={data}
                  template={emailContent}
                  filename={filename}
                  onSentToContact={onSentToContact}
                  language={this.state.language}
                />
              )}
            </React.Fragment>
          );
        };

        renderDocument = ({ component: Component, ...props }) => {
          const { documentProps } = this.state;
          if (!documentProps) return null;
          return (
            <Component
              t={this.props.t}
              onContentChanged={this.handleContentChanged}
              {...documentProps}
              {...props}
            />
          );
        };

        renderPackingSlipDocument = ({
          item,
          compact,
          label,
          to_print,
          emptyButton,
          validation,
          simplified,
          ...props
        }) => {
          const getLanguageAndType = (language) => () => {
            onDownload(this.props)((documentProps, filename) =>
              this.handleGetDocument(documentProps, filename, language), item);
          };

          let availableLangs = []

          if (this.selectedOrganisation?.is_trial) {
            availableLangs = Object.keys(languageNameMapping).filter(lang => lang !== 'en');
          } else {
            availableLangs = this.selectedOrganisation?.subscribed_features?.hesaablanguage?.filter(lang => lang !== 'en');
          }

          return (
            <UncontrolledButtonDropdown {...props}>
              <PendingButton
                pending={this.state.documentPending}
                component={DropdownToggle}
                caret
                color={"primary"}
                className={`btn-sm ${compact ? "py-0" : ""}`}
              >
                <span className={`fa fa-download ${emptyButton ? "" : "mr-1"}`} />
                {emptyButton ? "" : <>
                  {!compact ? ` ${label || "Packing Slip"}` : ""}</>}
              </PendingButton>
              <DropdownMenu>
                <DropdownItem onClick={getLanguageAndType('en')}>
                  <Trans>English</Trans>
                </DropdownItem>
                {availableLangs?.map(lang => (
                  languageNameMapping[lang] !== undefined && languageNameMapping[lang] !== "" && (
                    <DropdownItem key={lang} onClick={getLanguageAndType(lang)}>
                      <Trans>{languageNameMapping[lang]}</Trans>
                    </DropdownItem>
                  )
                ))}
              </DropdownMenu>
            </UncontrolledButtonDropdown>
          );
        };

        render = () => {
          const {
            handleGetDocument,
            renderDocument,
            state: { documentPending },
            props,
          } = this;
          return (
            <BaseComponent
              {...props}
              documentPending={documentPending}
              getDocument={handleGetDocument}
              DocumentRenderer={renderDocument}
              EmailDocument={this.renderEmailDocument}
              DownloadDocument={this.renderDownloadDocument}
              PrintDocument={this.renderPrintDocument}
              ShareDocument={this.renderWtspDocument}
              PackingSlipDocument={this.renderPackingSlipDocument}
            />
          );
        };
      }
  );

export default withDocumentRenderer;
